import { render, staticRenderFns } from "./GazetteHit.vue?vue&type=template&id=05249eab"
import script from "./GazetteHit.vue?vue&type=script&lang=js"
export * from "./GazetteHit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports